/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */


/**
 * Minimal wrapper that keeps the original callback/options together for consistent listener bookkeeping.
 */
export class ActorEventListener {

    constructor(actor, type, callback, options) {
        this.actor = actor;
        this.type = type;
        this.callback = callback;
        this.options = options;
    }
}